exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host .warning-icon {\n  color: #ffb812; }\n\n:host .error-icon {\n  color: red; }\n\n:host ::ng-deep .ui-progressbar.ui-progressbar-determinate .ui-progressbar-value {\n  background: #ffb812; }\n\n:host ::ng-deep .ui-sidebar-close {\n  display: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/core/components/server-notifications/server-notifications.component.scss
// module id = ../../../../../src/app/modules/core/components/server-notifications/server-notifications.component.scss
// module chunks = main